import React from 'react';
import { CType } from '../../provider/Typo3Provider/types';
import { contentComponents } from './components/contentComponentMapping';

export const getComponent = (content: CType) => {
  const type = content.CType;

  const SelectedComponent = contentComponents[type];

  if (!SelectedComponent) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`getComponent: component '${type}' not found`);
      return (
        <div key={content.uid}>
          <span style={{ color: 'red' }}>NICHT DEFINIERTE KOMPONENTE:</span>{' '}
          {type}
        </div>
      );
    }
    return null;
  }

  return <SelectedComponent key={content.uid} {...content} />;
};
